export default {
  remindUsername: {
    data: null,
    error: null,
    loading: false,
  },
};
